import React, { useState, useEffect } from 'react'
import { supabase } from '../supabase'
import { IconArrowLeft, IconSettings, IconCamera, IconPlus, IconChevronDown, IconStar, IconFlame, IconColorSwatch } from '@tabler/icons-react'

const STAGE_LABELS = { 'greenware': 'Greenware', 'bisque-fire': 'Bisque-fire', 'glaze-fire': 'Glaze-fire', 'delivered': '🍕 Delivered' }
const STAGES = ['greenware', 'bisque-fire', 'glaze-fire', 'delivered']

const PIZZA_SVG = (color) => (
  <svg width="13" height="13" viewBox="0 0 28 28" fill="none">
    <path d="M14 4 L26 22 Q14 27 2 22 Z" stroke={color} strokeWidth="2.2" fill="none" strokeLinejoin="round"/>
    <path d="M14 4 Q20 13 26 22" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M14 4 Q8 13 2 22" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M6 19 Q14 24 22 19" stroke={color} strokeWidth="2" fill="none" strokeLinecap="round"/>
    <circle cx="11" cy="15.5" r="1.8" fill={color}/>
    <circle cx="17" cy="13" r="1.8" fill={color}/>
  </svg>
)

const TEXTURES = [
  (t) => <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" style={{position:'absolute',inset:0}}><rect width="100%" height="100%" fill={t.border}/><circle cx="20%" cy="30%" r="3" fill={t.header} opacity=".2"/><circle cx="45%" cy="55%" r="2" fill={t.header} opacity=".18"/><circle cx="70%" cy="25%" r="3.5" fill={t.darkHeader} opacity=".14"/><circle cx="30%" cy="70%" r="2" fill={t.header} opacity=".18"/><circle cx="80%" cy="65%" r="1.5" fill={t.darkHeader} opacity=".22"/><circle cx="55%" cy="40%" r="4" fill={t.header} opacity=".1"/><circle cx="15%" cy="55%" r="2" fill={t.darkHeader} opacity=".18"/><circle cx="65%" cy="75%" r="3" fill={t.header} opacity=".15"/></svg>,
  (t) => <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" style={{position:'absolute',inset:0}} viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice"><rect width="100" height="100" fill={t.border}/><ellipse cx="22" cy="20" rx="14" ry="9" fill={t.header} opacity=".2" transform="rotate(-15 22 20)"/><ellipse cx="62" cy="38" rx="18" ry="10" fill={t.darkHeader} opacity=".15" transform="rotate(10 62 38)"/><ellipse cx="82" cy="18" rx="10" ry="7" fill={t.header} opacity=".18" transform="rotate(20 82 18)"/><ellipse cx="38" cy="65" rx="14" ry="8" fill={t.darkHeader} opacity=".16" transform="rotate(-8 38 65)"/><ellipse cx="75" cy="72" rx="12" ry="7" fill={t.header} opacity=".18" transform="rotate(15 75 72)"/></svg>,
  (t) => <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" style={{position:'absolute',inset:0}}><defs><radialGradient id="pw1" cx="30%" cy="40%" r="60%"><stop offset="0%" stopColor={t.border} stopOpacity=".95"/><stop offset="100%" stopColor={t.header} stopOpacity=".3"/></radialGradient><radialGradient id="pw2" cx="75%" cy="65%" r="50%"><stop offset="0%" stopColor={t.border} stopOpacity=".8"/><stop offset="100%" stopColor={t.darkHeader} stopOpacity=".25"/></radialGradient></defs><rect width="100%" height="100%" fill={t.border}/><ellipse cx="30%" cy="40%" rx="60%" ry="55%" fill="url(#pw1)" opacity=".8"/><ellipse cx="72%" cy="62%" rx="50%" ry="45%" fill="url(#pw2)" opacity=".7"/></svg>,
  (t) => <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" style={{position:'absolute',inset:0}}><defs><pattern id="ps" x="0" y="0" width="8" height="8" patternUnits="userSpaceOnUse"><rect width="8" height="8" fill={t.border}/><circle cx="1.5" cy="1.5" r=".7" fill={t.header} opacity=".2"/><circle cx="5.5" cy="4" r=".5" fill={t.darkHeader} opacity=".16"/><circle cx="3" cy="6.5" r=".7" fill={t.header} opacity=".18"/></pattern></defs><rect width="100%" height="100%" fill="url(#ps)"/></svg>,
  (t) => <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" style={{position:'absolute',inset:0}} viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice"><rect width="100" height="100" fill={t.border}/><circle cx="50" cy="50" r="10" fill="none" stroke={t.header} strokeWidth="1.5" opacity=".3"/><circle cx="50" cy="50" r="20" fill="none" stroke={t.header} strokeWidth="1.2" opacity=".25"/><circle cx="50" cy="50" r="30" fill="none" stroke={t.header} strokeWidth="1" opacity=".2"/><circle cx="50" cy="50" r="42" fill="none" stroke={t.header} strokeWidth=".8" opacity=".18"/><circle cx="50" cy="50" r="56" fill="none" stroke={t.header} strokeWidth=".7" opacity=".14"/></svg>,
  (t) => <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" style={{position:'absolute',inset:0}}><defs><pattern id="pc" x="0" y="0" width="8" height="8" patternUnits="userSpaceOnUse"><rect width="8" height="8" fill={t.border}/><line x1="0" y1="8" x2="8" y2="0" stroke={t.header} strokeWidth=".6" opacity=".22"/><line x1="0" y1="0" x2="8" y2="8" stroke={t.header} strokeWidth=".6" opacity=".22"/></pattern></defs><rect width="100%" height="100%" fill="url(#pc)"/></svg>,
]

export default function PieceCard({ pieceId, onBack, theme: t }) {
  const [piece, setPiece] = useState(null)
  const [photos, setPhotos] = useState([])
  const [glazePlan, setGlazePlan] = useState(null)
  const [clayBodies, setClayBodies] = useState([])
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [showStageDropdown, setShowStageDropdown] = useState(false)
  const [glazeNames, setGlazeNames] = useState([])
  const [uploadingPhoto, setUploadingPhoto] = useState(false)
  const [showFavoritePicker, setShowFavoritePicker] = useState(false)
const [favorites, setFavorites] = useState([])
  const [showNewClayBody, setShowNewClayBody] = useState(false)
const [newClayBodyName, setNewClayBodyName] = useState('')

  useEffect(() => {
    fetchAll()
  }, [pieceId])

  const fetchAll = async () => {
    const [pieceRes, photosRes, glazePlanRes, clayRes, glazeNamesRes] = await Promise.all([
      supabase.from('pieces').select('*').eq('id', pieceId).single(),
      supabase.from('photos').select('*').eq('piece_id', pieceId).order('created_at'),
      supabase.from('glaze_plans').select('*').eq('piece_id', pieceId).single(),
      supabase.from('clay_bodies').select('*').order('name'),
      supabase.from('glazes').select('name').order('name'),
    ])
    if (pieceRes.data) setPiece(pieceRes.data)
    if (photosRes.data) setPhotos(photosRes.data)
    if (glazePlanRes.data) setGlazePlan(glazePlanRes.data)
    else setGlazePlan({ has_separate_interior: false, exterior_layers: [''], interior_layers: [''] })
    if (clayRes.data) setClayBodies(clayRes.data)
    if (glazeNamesRes.data) setGlazeNames(glazeNamesRes.data.map(g => g.name))
    setLoading(false)
  }

  const updatePiece = async (updates) => {
    setSaving(true)
    const { data } = await supabase.from('pieces').update({ ...updates, updated_at: new Date() }).eq('id', pieceId).select().single()
    if (data) setPiece(data)
    setSaving(false)
  }

  const updateStage = async (stage) => {
    const updates = { firing_stage: stage }
    if (stage === 'bisque-fire' && !piece.bisque_date) updates.bisque_date = new Date().toISOString().split('T')[0]
    if (stage === 'glaze-fire' && !piece.glaze_date) updates.glaze_date = new Date().toISOString().split('T')[0]
    if (stage === 'delivered' && !piece.pickup_date) updates.pickup_date = new Date().toISOString().split('T')[0]
    await updatePiece(updates)
    setShowStageDropdown(false)
  }

  const saveGlazePlan = async (updatedPlan) => {
    const planToSave = { ...glazePlan, ...updatedPlan, piece_id: pieceId }
    if (glazePlan?.id) {
      await supabase.from('glaze_plans').update(planToSave).eq('id', glazePlan.id)
    } else {
      const { data } = await supabase.from('glaze_plans').insert(planToSave).select().single()
      if (data) setGlazePlan(data)
    }
    const allGlazes = [...(planToSave.exterior_layers || []), ...(planToSave.interior_layers || [])].filter(Boolean)
    for (const name of allGlazes) {
      await supabase.from('glazes').upsert({ name }, { onConflict: 'name' })
    }
  }

  const saveAsFavorite = async () => {
    if (!glazePlan) return
    const layers = (glazePlan.exterior_layers || []).filter(Boolean)
    if (layers.length === 0) return
    const name = glazePlan.has_separate_interior
      ? `${layers.join(' + ')} (ext) · ${(glazePlan.interior_layers || []).filter(Boolean).join(' + ')} (int)`
      : layers.join(' + ')
    await supabase.from('glaze_favorites').insert({
      name,
      exterior_layers: glazePlan.exterior_layers,
      interior_layers: glazePlan.interior_layers,
      has_separate_interior: glazePlan.has_separate_interior,
      preview_photo_url: piece.default_photo_url || null
    })
    alert('Saved to favorites!')
  }

  const fetchFavorites = async () => {
    const { data } = await supabase.from('glaze_favorites').select('*').order('created_at', { ascending: false })
    if (data) setFavorites(data)
  }

  const applyFavorite = async (fave) => {
    const updated = {
      ...glazePlan,
      exterior_layers: fave.exterior_layers,
      interior_layers: fave.interior_layers,
      has_separate_interior: fave.has_separate_interior
    }
    setGlazePlan(updated)
    await saveGlazePlan(updated)
    setShowFavoritePicker(false)
  }

    const handlePhotoUpload = async (e) => {
    const file = e.target.files[0]
    if (!file) return
    setUploadingPhoto(true)
    try {
      const fileName = `${pieceId}/${Date.now()}_${file.name.replace(/[^a-zA-Z0-9._-]/g, '_')}`
      const { error: uploadError } = await supabase.storage.from('photos').upload(fileName, file)
      if (uploadError) { console.error('Upload error:', uploadError); setUploadingPhoto(false); return }
      const { data: { publicUrl } } = supabase.storage.from('photos').getPublicUrl(fileName)
      await supabase.from('photos').update({ is_default: false }).eq('piece_id', pieceId)
      const { data: photoData } = await supabase.from('photos').insert({ piece_id: pieceId, url: publicUrl, is_default: true }).select().single()
      if (photoData) {
        setPhotos(prev => [...prev, photoData].map(p => ({ ...p, is_default: p.id === photoData.id })))
        await updatePiece({ default_photo_url: publicUrl })
      }
    } catch (err) {
      console.error('Photo upload failed:', err)
    }
    setUploadingPhoto(false)
  }

  const setDefaultPhoto = async (photo) => {
    await supabase.from('photos').update({ is_default: false }).eq('piece_id', pieceId)
    await supabase.from('photos').update({ is_default: true }).eq('id', photo.id)
    await updatePiece({ default_photo_url: photo.url })
    setPhotos(prev => prev.map(p => ({ ...p, is_default: p.id === photo.id })))
  }

  if (loading) return <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: t.bg, fontFamily: 'Jost, sans-serif', color: t.textLight }}>Loading...</div>
  if (!piece) return null

  const showGlaze = ['bisque-fire', 'glaze-fire', 'delivered'].includes(piece.firing_stage)
  const showDelivered = ['glaze-fire', 'delivered'].includes(piece.firing_stage)

  return (
    <div style={{ fontFamily: 'Jost, sans-serif', background: t.bg, minHeight: '100vh', maxWidth: '430px', margin: '0 auto' }}>

      {/* HERO */}
      <div style={{ height: '200px', background: `linear-gradient(160deg, ${t.darkHeader} 0%, ${t.header} 100%)`, position: 'relative', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {piece.default_photo_url ? (
          <img src={piece.default_photo_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', inset: 0 }}/>
        ) : (
          <div style={{ position: 'absolute', inset: 0 }}>{TEXTURES[(piece.texture_index || 1) - 1](t)}</div>
        )}
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(0,0,0,.2) 0%, rgba(0,0,0,.6) 100%)' }}/>
        <div onClick={onBack} style={{ position: 'absolute', top: '48px', left: '14px', background: 'rgba(0,0,0,.25)', borderRadius: '10px', padding: '5px 12px', fontSize: '12px', color: '#e8f8f6', cursor: 'pointer', zIndex: 2, display: 'flex', alignItems: 'center', gap: '4px' }}>
          <IconArrowLeft size={14}/> Library
        </div>
        <div style={{ position: 'absolute', top: '44px', right: '14px', width: '32px', height: '32px', borderRadius: '50%', background: 'rgba(0,0,0,.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 2 }}>
          <IconSettings size={15} color="#e8f8f6"/>
        </div>
        <div style={{ position: 'absolute', bottom: '14px', left: '14px', zIndex: 2 }}>
          <div style={{ fontFamily: 'Alike, serif', fontSize: '22px', color: '#e8f8f6', lineHeight: 1.1 }}>{piece.unique_id}</div>
          <div style={{ fontSize: '10px', fontWeight: '300', color: 'rgba(232,248,246,.7)', marginTop: '3px' }}>
            {new Date(piece.date_created).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })} · {piece.type_tag}
          </div>
        </div>
      </div>

      {/* PROGRESS TRACKER */}
      <div style={{ background: t.darkHeader, padding: '12px 16px', display: 'flex', alignItems: 'center' }}>
        {STAGES.map((stage, i) => (
          <React.Fragment key={stage}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
              <div style={{ width: '28px', height: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', zIndex: 1, background: piece.firing_stage === stage ? t.accent : STAGES.indexOf(piece.firing_stage) > i ? 'rgba(255,255,255,.2)' : 'rgba(255,255,255,.08)', border: piece.firing_stage === stage ? `2px solid ${t.accentDark}` : STAGES.indexOf(piece.firing_stage) > i ? '2px solid rgba(255,255,255,.38)' : '2px solid rgba(255,255,255,.18)' }}>
                {stage === 'delivered' ? PIZZA_SVG(piece.firing_stage === stage ? t.accentText : 'rgba(255,255,255,.4)') : stage === 'bisque-fire' ? <IconFlame size={12} color={piece.firing_stage === stage ? t.accentText : 'rgba(255,255,255,.4)'}/> : stage === 'glaze-fire' ? <IconColorSwatch size={12} color={piece.firing_stage === stage ? t.accentText : 'rgba(255,255,255,.4)'}/> : <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: STAGES.indexOf(piece.firing_stage) > i ? 'rgba(255,255,255,.7)' : 'rgba(255,255,255,.3)' }}/>}
              </div>
              <div style={{ fontSize: '7.5px', color: piece.firing_stage === stage ? t.accent : STAGES.indexOf(piece.firing_stage) > i ? 'rgba(255,255,255,.7)' : 'rgba(255,255,255,.4)', marginTop: '4px', textAlign: 'center', lineHeight: 1.2 }}>
                {stage === 'bisque-fire' ? 'Bisque' : stage === 'glaze-fire' ? 'Glaze' : stage === 'delivered' ? 'Delivered' : 'Greenware'}
              </div>
            </div>
            {i < STAGES.length - 1 && (
              <div style={{ flex: 1, height: '2px', marginTop: '-18px', background: STAGES.indexOf(piece.firing_stage) > i ? 'rgba(255,255,255,.35)' : 'rgba(255,255,255,.14)' }}/>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* BODY */}
      <div style={{ padding: '14px' }}>

        {/* PHOTOS */}
        <div style={{ marginBottom: '18px' }}>
          <div style={{ fontSize: '9px', fontWeight: '500', letterSpacing: '1.2px', textTransform: 'uppercase', color: t.textLight, borderBottom: `1px solid ${t.border}`, paddingBottom: '6px', marginBottom: '10px' }}>Photos</div>
          <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', scrollbarWidth: 'none', paddingBottom: '4px' }}>
            {photos.map(photo => (
              <div key={photo.id} style={{ width: '74px', height: '74px', borderRadius: '12px', flexShrink: 0, position: 'relative', overflow: 'hidden', border: photo.is_default ? `2.5px solid ${t.accent}` : `2px solid ${t.border}` }}>
                <img src={photo.url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
                {!photo.is_default && (
                  <div onClick={() => setDefaultPhoto(photo)} style={{ position: 'absolute', bottom: '3px', left: '50%', transform: 'translateX(-50%)', background: 'rgba(0,0,0,.6)', borderRadius: '6px', padding: '2px 5px', fontSize: '7px', color: '#fff', whiteSpace: 'nowrap', cursor: 'pointer' }}>Set default</div>
                )}
                {photo.is_default && (
                  <div style={{ position: 'absolute', bottom: '3px', left: '50%', transform: 'translateX(-50%)', background: t.accent, borderRadius: '6px', padding: '2px 6px', fontSize: '7px', color: t.accentText, whiteSpace: 'nowrap' }}>Default</div>
                )}
              </div>
            ))}
            <label style={{ width: '74px', height: '74px', borderRadius: '12px', border: `1.5px dashed ${t.border}`, flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '4px', color: t.textLight, fontSize: '9px', cursor: 'pointer' }}>
              <input type="file" accept="image/*" onChange={handlePhotoUpload} style={{ display: 'none' }}/>
              {uploadingPhoto ? '...' : <><IconCamera size={20}/> Add</>}
            </label>
          </div>
        </div>

        {/* OVERVIEW */}
        <div style={{ marginBottom: '18px' }}>
          <div style={{ fontSize: '9px', fontWeight: '500', letterSpacing: '1.2px', textTransform: 'uppercase', color: t.textLight, borderBottom: `1px solid ${t.border}`, paddingBottom: '6px', marginBottom: '10px' }}>Overview</div>

                    {/* Firing stage */}
          <div style={{ marginBottom: '10px', position: 'relative' }}>
            <div style={{ fontSize: '9px', fontWeight: '500', letterSpacing: '.7px', textTransform: 'uppercase', color: t.textLight, marginBottom: '4px' }}>Firing Stage</div>
            <div onClick={() => setShowStageDropdown(!showStageDropdown)} style={{ background: t.card, border: `1px solid ${t.border}`, borderRadius: '10px', padding: '9px 12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}>
              <div style={{ background: t.accent, color: t.accentText, borderRadius: '8px', padding: '3px 10px', fontSize: '11px', fontWeight: '500' }}>
                {STAGE_LABELS[piece.firing_stage]}
                {piece.bisque_date && piece.firing_stage === 'bisque-fire' ? ` · ${new Date(piece.bisque_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}` : ''}
                {piece.glaze_date && piece.firing_stage === 'glaze-fire' ? ` · ${new Date(piece.glaze_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}` : ''}
              </div>
              <IconChevronDown size={14} color={t.textLight}/>
            </div>
            {showStageDropdown && (
              <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: t.card, border: `1px solid ${t.border}`, borderRadius: '10px', overflow: 'hidden', zIndex: 20, boxShadow: '0 4px 12px rgba(0,0,0,.1)' }}>
                {STAGES.map(s => (
                  <div key={s} onClick={() => updateStage(s)} style={{ padding: '10px 14px', fontSize: '13px', color: piece.firing_stage === s ? t.header : t.text, background: piece.firing_stage === s ? `${t.header}15` : 'transparent', cursor: 'pointer', fontWeight: piece.firing_stage === s ? '500' : '400' }}>
                    {STAGE_LABELS[s]}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Clay body */}
          <div style={{ marginBottom: '10px' }}>
  <div style={{ fontSize: '9px', fontWeight: '500', letterSpacing: '.7px', textTransform: 'uppercase', color: t.textLight, marginBottom: '4px' }}>Clay Body</div>
  {!showNewClayBody ? (
    <div style={{ display: 'flex', gap: '8px' }}>
      <select
        value={piece.clay_body_id || ''}
        onChange={e => {
          if (e.target.value === 'new') { setShowNewClayBody(true) }
          else updatePiece({ clay_body_id: e.target.value || null })
        }}
        style={{ flex: 1, background: t.card, border: `1px solid ${t.border}`, borderRadius: '10px', padding: '9px 12px', fontSize: '13px', color: t.text, outline: 'none', fontFamily: 'Jost, sans-serif' }}
      >
        <option value="">Select clay body...</option>
        {clayBodies.map(cb => <option key={cb.id} value={cb.id}>{cb.name}</option>)}
        <option value="new">+ Add new clay body</option>
      </select>
    </div>
  ) : (
    <div style={{ display: 'flex', gap: '8px' }}>
      <input
        autoFocus
        value={newClayBodyName}
        onChange={e => setNewClayBodyName(e.target.value)}
        placeholder="e.g. Standard 266"
        style={{ flex: 1, background: t.card, border: `1px solid ${t.border}`, borderRadius: '10px', padding: '9px 12px', fontSize: '13px', color: t.text, outline: 'none', fontFamily: 'Jost, sans-serif' }}
      />
      <div onClick={async () => {
        if (!newClayBodyName.trim()) return
        const { data } = await supabase.from('clay_bodies').insert({ name: newClayBodyName.trim() }).select().single()
        if (data) {
          setClayBodies(prev => [...prev, data])
          await updatePiece({ clay_body_id: data.id })
        }
        setNewClayBodyName('')
        setShowNewClayBody(false)
      }} style={{ padding: '9px 14px', borderRadius: '10px', background: t.header, color: '#e8f8f6', fontSize: '12px', fontWeight: '500', cursor: 'pointer', whiteSpace: 'nowrap' }}>
        Save
      </div>
      <div onClick={() => setShowNewClayBody(false)} style={{ padding: '9px 12px', borderRadius: '10px', background: t.bg, border: `1px solid ${t.border}`, fontSize: '12px', color: t.textLight, cursor: 'pointer' }}>
        ✕
      </div>
    </div>
  )}
</div>

          {/* Destination */}
          <div style={{ marginBottom: '10px' }}>
            <div style={{ fontSize: '9px', fontWeight: '500', letterSpacing: '.7px', textTransform: 'uppercase', color: t.textLight, marginBottom: '4px' }}>Destination</div>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
              {['gift', 'sale', 'keep'].map(d => (
                <div key={d} onClick={() => updatePiece({ destination: d })} style={{ flex: 1, textAlign: 'center', borderRadius: '10px', padding: '8px', fontSize: '12px', cursor: 'pointer', background: piece.destination === d ? t.header : t.card, color: piece.destination === d ? '#e8f8f6' : t.textLight, border: `1px solid ${piece.destination === d ? t.header : t.border}` }}>
                  {d.charAt(0).toUpperCase() + d.slice(1)}
                </div>
              ))}
            </div>
            {(piece.destination === 'gift' || piece.destination === 'sale') && (
              <input
                value={piece.destination_note || ''}
                onChange={e => updatePiece({ destination_note: e.target.value })}
                placeholder={piece.destination === 'gift' ? 'For who?' : 'Notes...'}
                style={{ width: '100%', background: t.card, border: `1px solid ${t.border}`, borderRadius: '10px', padding: '9px 12px', fontSize: '13px', color: t.text, outline: 'none', fontFamily: 'Jost, sans-serif', boxSizing: 'border-box' }}
              />
            )}
          </div>



          {/* Notes */}
          <div>
            <div style={{ fontSize: '9px', fontWeight: '500', letterSpacing: '.7px', textTransform: 'uppercase', color: t.textLight, marginBottom: '4px' }}>Notes</div>
            <textarea
              value={piece.notes || ''}
              onChange={e => updatePiece({ notes: e.target.value })}
              placeholder="Any notes about this piece..."
              style={{ width: '100%', background: t.card, border: `1px solid ${t.border}`, borderRadius: '10px', padding: '9px 12px', fontSize: '11px', fontWeight: '300', color: t.text, outline: 'none', fontFamily: 'Jost, sans-serif', fontStyle: 'italic', resize: 'none', minHeight: '64px', boxSizing: 'border-box' }}
            />
          </div>
        </div>

        {/* GLAZE PLAN */}
        {showGlaze && glazePlan && (
          <div style={{ marginBottom: '18px' }}>
            <div style={{ fontSize: '9px', fontWeight: '500', letterSpacing: '1.2px', textTransform: 'uppercase', color: t.textLight, borderBottom: `1px solid ${t.border}`, paddingBottom: '6px', marginBottom: '10px' }}>Glaze Plan</div>

            {/* Interior toggle */}
            <div onClick={() => { const updated = { ...glazePlan, has_separate_interior: !glazePlan.has_separate_interior }; setGlazePlan(updated); saveGlazePlan(updated) }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: t.card, border: `1px solid ${t.border}`, borderRadius: '10px', padding: '10px 12px', marginBottom: '12px', cursor: 'pointer' }}>
              <div style={{ fontSize: '13px', fontWeight: '400', color: t.text }}>Different interior glaze</div>
              <div style={{ width: '38px', height: '22px', borderRadius: '11px', background: glazePlan.has_separate_interior ? t.header : t.border, position: 'relative', transition: 'background .2s' }}>
                <div style={{ width: '18px', height: '18px', borderRadius: '50%', background: 'white', position: 'absolute', top: '2px', left: glazePlan.has_separate_interior ? '18px' : '2px', transition: 'left .2s', boxShadow: '0 1px 3px rgba(0,0,0,.2)' }}/>
              </div>
            </div>

                       {/* Interior layers - shown first when toggle is on */}
            {glazePlan.has_separate_interior && (
              <div style={{ marginBottom: '12px' }}>
                <div style={{ fontSize: '9px', fontWeight: '500', letterSpacing: '.7px', textTransform: 'uppercase', color: t.textLight, marginBottom: '6px' }}>Interior</div>
                {(glazePlan.interior_layers || ['']).map((layer, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '7px 0', borderBottom: `1px solid ${t.border}40` }}>
                    <div style={{ fontSize: '11px', fontWeight: '300', color: t.textLight, width: '16px', flexShrink: 0 }}>{i + 1}.</div>
                    <input
                      value={layer}
                      onChange={e => { const layers = [...(glazePlan.interior_layers || [''])]; layers[i] = e.target.value; const updated = { ...glazePlan, interior_layers: layers }; setGlazePlan(updated) }}
                      onBlur={e => { const layers = [...(glazePlan.interior_layers || [''])]; layers[i] = e.target.value; const updated = { ...glazePlan, interior_layers: layers }; saveGlazePlan(updated) }}
                      placeholder="Glaze name..."
                      list="glaze-suggestions"
                      style={{ flex: 1, background: 'none', border: 'none', borderBottom: `1px solid ${t.border}`, padding: '2px 0', fontSize: '13px', color: t.text, outline: 'none', fontFamily: 'Jost, sans-serif' }}
                    />
                  </div>
                ))}
                <div onClick={() => { const updated = { ...glazePlan, interior_layers: [...(glazePlan.interior_layers || ['']), ''] }; setGlazePlan(updated); saveGlazePlan(updated) }} style={{ fontSize: '11px', fontWeight: '400', color: t.header, marginTop: '10px', display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
                  <IconPlus size={13}/> Add layer
                </div>
              </div>
            )}

            {/* Exterior layers */}
            <div>
              {glazePlan.has_separate_interior && <div style={{ fontSize: '9px', fontWeight: '500', letterSpacing: '.7px', textTransform: 'uppercase', color: t.textLight, marginBottom: '6px' }}>Exterior</div>}
              {(glazePlan.exterior_layers || ['']).map((layer, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '7px 0', borderBottom: `1px solid ${t.border}40` }}>
                  <div style={{ fontSize: '11px', fontWeight: '300', color: t.textLight, width: '16px', flexShrink: 0 }}>{i + 1}.</div>
                  <input
                    value={layer}
                    onChange={e => { const layers = [...(glazePlan.exterior_layers || [''])]; layers[i] = e.target.value; const updated = { ...glazePlan, exterior_layers: layers }; setGlazePlan(updated) }}
                    onBlur={e => { const layers = [...(glazePlan.exterior_layers || [''])]; layers[i] = e.target.value; const updated = { ...glazePlan, exterior_layers: layers }; saveGlazePlan(updated) }}
                    placeholder="Glaze name..."
                    list="glaze-suggestions"
                    style={{ flex: 1, background: 'none', border: 'none', borderBottom: `1px solid ${t.border}`, padding: '2px 0', fontSize: '13px', color: t.text, outline: 'none', fontFamily: 'Jost, sans-serif' }}
                  />
                </div>
              ))}
              <datalist id="glaze-suggestions">{glazeNames.map(n => <option key={n} value={n}/>)}</datalist>
              <div onClick={() => { const updated = { ...glazePlan, exterior_layers: [...(glazePlan.exterior_layers || ['']), ''] }; setGlazePlan(updated); saveGlazePlan(updated) }} style={{ fontSize: '11px', fontWeight: '400', color: t.header, marginTop: '10px', display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
                <IconPlus size={13}/> Add layer
              </div>
            </div>

            {/* Favorites buttons */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '12px' }}>
              <div onClick={() => setShowFavoritePicker(true)} style={{ border: `1px solid ${t.border}`, borderRadius: '10px', padding: '9px 12px', fontSize: '11px', fontWeight: '400', color: t.header, background: t.card, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                <IconStar size={14}/> Select from favorites
              </div>
              <div onClick={saveAsFavorite} style={{ border: `1px solid ${t.border}`, borderRadius: '10px', padding: '9px 12px', fontSize: '11px', fontWeight: '400', color: t.header, background: t.card, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                <IconStar size={14}/> Save as favorite
              </div>
            </div>
          </div>
        )}

        {/* PIZZA DELIVERED */}
        {showDelivered && (
          <div style={{ marginBottom: '18px' }}>
            <div style={{ fontSize: '9px', fontWeight: '500', letterSpacing: '1.2px', textTransform: 'uppercase', color: t.textLight, borderBottom: `1px solid ${t.border}`, paddingBottom: '6px', marginBottom: '10px' }}>Pickup</div>
            <div onClick={() => updateStage('delivered')} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: piece.firing_stage === 'delivered' ? `${t.header}15` : t.card, border: `1px solid ${piece.firing_stage === 'delivered' ? t.header : t.border}`, borderRadius: '12px', padding: '12px 14px', cursor: 'pointer' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {PIZZA_SVG(piece.firing_stage === 'delivered' ? t.header : t.textLight)}
                <div>
                  <div style={{ fontSize: '13px', fontWeight: '400', color: piece.firing_stage === 'delivered' ? t.header : t.text }}>Pizza Delivered!</div>
                  {piece.pickup_date && <div style={{ fontSize: '10px', fontWeight: '300', color: t.textLight, marginTop: '1px' }}>{new Date(piece.pickup_date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</div>}
                </div>
              </div>
              <div style={{ width: '22px', height: '22px', borderRadius: '50%', border: `2px solid ${piece.firing_stage === 'delivered' ? t.header : t.border}`, background: piece.firing_stage === 'delivered' ? t.header : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {piece.firing_stage === 'delivered' && <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#fff' }}/>}
              </div>
            </div>
          </div>
        )}

      </div>
      {showFavoritePicker && (
        <div onClick={() => setShowFavoritePicker(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 50, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
          <div onClick={e => e.stopPropagation()} style={{ background: t.card, borderRadius: '20px 20px 0 0', width: '100%', maxWidth: '430px', padding: '24px', paddingBottom: '48px', maxHeight: '70vh', overflowY: 'auto' }}>
            <div style={{ width: '40px', height: '4px', borderRadius: '2px', background: t.border, margin: '0 auto 16px' }}/>
            <div style={{ fontFamily: 'Dancing Script, cursive', fontSize: '22px', color: t.header, marginBottom: '16px' }}>Select a favorite</div>
            {favorites.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '24px', color: t.textLight, fontSize: '13px' }}>No favorites saved yet</div>
            ) : (
              favorites.map(fave => (
                <div key={fave.id} onClick={() => applyFavorite(fave)} style={{ background: t.bg, border: `1px solid ${t.border}`, borderRadius: '12px', padding: '10px 12px', marginBottom: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  {fave.preview_photo_url && (
                    <img src={fave.preview_photo_url} alt="" style={{ width: '48px', height: '48px', borderRadius: '8px', objectFit: 'cover', flexShrink: 0 }}/>
                  )}
                  <div>
                    <div style={{ fontFamily: 'Alike, serif', fontSize: '12px', color: t.text, marginBottom: '3px' }}>{fave.name}</div>
                    <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                      {(fave.exterior_layers || []).filter(Boolean).map((layer, i) => (
                        <div key={i} style={{ fontSize: '9px', padding: '2px 6px', borderRadius: '6px', background: t.card, border: `1px solid ${t.border}`, color: t.textLight }}>{layer}</div>
                      ))}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  )
}